/**
 * @export
 * @class Global
 */
import * as Choices from 'choices.js'

// @ts-ignore
import * as Flickity from 'flickity'; // tslint:disable-line
import * as SmoothScroll from 'smooth-scroll';

import { PolyFills } from './polyfills'; // tslint:disable-line

import { Animations } from '../../animations'; // tslint:disable-line
import { Blocks } from '../../blocks';
import { getAll, getParameterByName, isTouchDevice } from '../../helpers/utilities';

import { Cookies } from './cookies';
import { SiteHeader } from './site-header';
import { SiteNav } from './site-nav';
import { Validation } from './validation';

declare global {
    interface Element {
        choices: Choices.default;
    }
    interface Window {
        flickity: Flickity;
        smoothScroll: SmoothScroll;
    }
}

export class Global {
    public static id = '*';

    
    /**
     * Creates an instance of Global.
     * 
     * @memberof Global
     */
    constructor() {

        // Autoinitiate flickity
        // @ts-ignore
        window.flickity = Flickity; // tslint:disable-line

        // SmoothScroll
        window.smoothScroll = new SmoothScroll('a[href*="#"]', {
            offset: 87
        });

        // Detect touch devices
        if(isTouchDevice()) {
            document.body.classList.add('u-is-touch-device');
        }
        
        if(window.location.pathname !== '/' && getParameterByName('mailing_list')) {
            const form = document.getElementById('gform_wrapper_1');
            if(form) {
                form.scrollIntoView();
            }
        }

        // Initiate our classes
        new Blocks();
        new SiteNav();
        new PolyFills();
        new Animations();
        new Validation();
        new SiteHeader();
        new Cookies();

        // Style custom select boxes
        this.dropdowns();

        // Open links in a new window
        this.newWindowLinks();
    }


    /**
     * Initiate our custom dropdowns
     * 
     * @private
     * @returns void
     */
    private dropdowns(): void {
        const dropdowns = getAll('.js-select-box') as Element[];
        if(dropdowns) {
            dropdowns.forEach(dropdown => {

                // @ts-ignore
                dropdown.choices = new Choices(dropdown, {
                    itemSelectText: '',
                    searchEnabled: false,
                    shouldSort: false
                });
            });
        }
    }


    /**
     * Open links in a new window
     * 
     * @private
     * @returns void
     */
    private newWindowLinks(): void {
        document.addEventListener('click', (event) => {
            const eventTarget = (event.target) as HTMLAnchorElement;
            const target      = eventTarget.classList.contains('js-new-window') ? eventTarget : eventTarget.closest('.js-new-window') as HTMLAnchorElement;
            if(target) {
                window.open(target.href, '_BLANK', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
                event.preventDefault();
            }
        });
    }
}
